module.exports = __webpack_public_path__ + "img/vertical_4_4_9016.724f8f86.png";